var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharactersBgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 809,
    viewBox: "0 0 1440 809",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820296 106.758 -41.0205)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 228.758 -41.0205)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 350.758 -41.0205)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 472.758 -41.0205)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820296 595.758 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 717.76 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 839.758 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 962.758 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 1084.76 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820294 1206.76 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1020,
    y2: -0.5,
    transform: "matrix(0 1 -0.999966 -0.00820296 1329.76 -41.0203)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1438.07 76.5919)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1439.07 198.888)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1440.07 321.184)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1441.08 443.48)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1442.08 565.774)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 1447.06,
    y2: -0.5,
    transform: "matrix(-1 -1.37998e-08 -0.00820299 -0.999966 1443.08 688.071)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 228.316 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 236.367 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 718.314 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 726.365 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1206.31 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1214.37 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 473.314 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 481.365 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 963.312 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 971.363 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 106.014 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 114.064 564.277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 596.012 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 604.062 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1084.01 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1092.06 564.277)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.713 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 358.764 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.715 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 848.766 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.71 557.977)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1336.76 564.276)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 228.301 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 718.301 802.969)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1206.3 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 473.301 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 963.301 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 106 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 595.998 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1084 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.699 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.699 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.7 802.968)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 228.299 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 236.35 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 718.299 313.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 726.35 320.284)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1206.3 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1214.35 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 473.299 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 481.35 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 963.299 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 971.35 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 105.998 313.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 114.049 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 595.996 313.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 604.047 320.284)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1084 313.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1092.05 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.697 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 358.748 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.697 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 848.748 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.7 313.983)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1336.75 320.283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 227.814 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 235.865 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 717.816 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 725.867 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1205.81 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1213.87 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 472.814 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 480.865 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 962.814 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 970.865 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 105.514 67.9923)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 113.564 74.2921)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 595.514 67.9924)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 603.564 74.2922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1083.51 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1091.56 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.213 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 358.264 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.213 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 848.264 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.21 67.9922)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1336.26 74.292)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 228.301 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 236.352 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 718.301 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 726.352 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1206.3 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1214.35 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 473.301 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 481.352 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 963.301 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 971.352 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 106 435.981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 114.051 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 595.998 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 604.049 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1084 435.981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1092.05 442.281)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.699 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 358.75 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.699 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 848.75 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.7 435.98)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1336.75 442.28)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 229.322 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 237.373 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 719.32 680.973)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 727.371 687.272)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1207.32 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1215.37 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 474.32 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 482.371 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 964.318 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 972.369 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 107.02 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 115.07 687.272)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 597.018 680.973)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 605.068 687.272)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1085.02 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1093.07 687.272)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 351.719 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 359.77 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 841.721 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 849.771 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1329.72 680.972)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1337.77 687.271)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 228.301 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 236.352 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 718.303 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 726.354 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1206.3 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1214.35 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 473.301 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 481.352 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 963.301 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 971.352 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 106 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 114.051 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 596 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 604.051 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1084 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1092.05 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 350.699 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 358.75 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 840.699 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 848.75 198.288)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(1 0 0.00820296 0.999966 1328.7 191.988)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.00820293 0.999966 -1 -4.33708e-08 1336.75 198.288)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharactersBgGrid);
export default __webpack_public_path__ + "static/media/characters-bg-grid.f34e64e230784244839a2d89bbf0fc15.svg";
export { ForwardRef as ReactComponent };